import * as React from 'react'
// libs
import moment from 'moment'
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import AvatarsList from 'components/PageComponents/Plans/Edit/components/ObjectivesListPreview/components/PlanDetails/components/AvatarsList'
// constants
import { REVIEW_STATUSES } from 'constants/review'
// themes
import { colors } from 'themes'
// types
import { IPlan, IReview, IScheduledReviewer } from 'types/graphql'
// views
import {
  DueDateWrapper,
  DueIndicator,
  InfoWrapper,
  ProgressIndicator,
  ReviewIcon,
  TextSeparator
} from 'components/Modals/PlanItems/components/CompleteReview/views'
// utils
import { get } from 'lodash'
import { getClosestReview } from 'utils/reviews'

// styled
const ReviewCardWrapper = styled.div`
  align-items: center;
  background-color: ${colors.white100};
  display: flex;
  margin-top: 10px;
  min-height: 70px;
  padding-left: 16px;
`

// types
interface IIncomingProps {
  plan: IPlan
}

const ClosestReview: React.FC<IIncomingProps> = ({ plan }) => {
  const avatarsLimit: number = 5

  const review: IReview & any = getClosestReview(plan)

  if (!review) {
    return null
  }

  const isDueToday: boolean = moment().isSame(review.dueDate, 'day')
  const isOverdue: boolean = moment().isAfter(review.dueDate, 'day')

  const reviewers: IScheduledReviewer = get(review, 'scheduledReview.scheduledReviewers')
  const reviewStatus: string = get(review, 'status', REVIEW_STATUSES.NOT_STARTED)

  return (
    <ReviewCardWrapper>
      <ReviewIcon />
      <InfoWrapper container>
        <DueDateWrapper>{`Review due ${moment(review.dueDate).format('D MMM YYYY')}`}</DueDateWrapper>
        <Grid container>
          <ProgressIndicator>{reviewStatus.replace('_', ' ')}</ProgressIndicator>
          {(isDueToday || isOverdue) && (
            <>
              <TextSeparator>|</TextSeparator>
              <DueIndicator isDueToday={isDueToday}>{isDueToday ? 'DUE TODAY' : 'OVERDUE'}</DueIndicator>
            </>
          )}
        </Grid>
      </InfoWrapper>
      <AvatarsList list={reviewers} limit={avatarsLimit} />
    </ReviewCardWrapper>
  )
}

export default ClosestReview
